export default __webpack_public_path__ + "static/media/WHITE_PAGES.d3cfc681.png";